const TodoStatusEnum = {
  OPEN: 'open',
  DUE: 'due',
  OVERDUE: 'overdue',
  DECLINED: 'declined',
  DONE: 'done',
}

export default Object.freeze(TodoStatusEnum)
